export default __webpack_public_path__ + "static/media/mirage_02.2403368a.jpg";